(function() {
  'use strict';

  class ButtonPriceManager {
    constructor() {
      this.submitButton = null;
      this.priceDisplay = null;
      this.basePrice = 0;
      this.init();
    }

    init() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.setup());
      } else {
        this.setup();
      }
    }

    setup() {
      this.submitButton = document.querySelector('.product-form__submit');
      this.priceDisplay = document.querySelector('[data-price-display]');

      if (!this.submitButton || !this.priceDisplay) {
        return;
      }

      const basePrice = this.submitButton.dataset.productPrice;
      if (basePrice) {
        this.basePrice = parseInt(basePrice);
      }

      // Écouter les événements de changement de prix depuis bundle-pack
      this.lastBundleDetail = null;
      document.addEventListener('bundlePackPrice:change', (e) => {
        this.lastBundleDetail = e.detail;
        this.updatePrice(e.detail);
      });



      // Écouter les changements de variante
      const variantSelects = document.querySelectorAll('.product-form select[name="id"]');
      variantSelects.forEach(select => {
        select.addEventListener('change', () => {
          this.updatePriceFromVariant();
        });
      });

      const variantRadios = document.querySelectorAll('.product-form input[type="radio"][name="id"]');
      variantRadios.forEach(radio => {
        radio.addEventListener('change', () => {
          this.updatePriceFromVariant();
        });
      });
    }

    updatePrice(detail) {
      if (!this.priceDisplay) return;

      const { totalPrice, totalPriceBeforeDiscount, totalCompareAtPrice, hasSelections, discount } = detail;

      if (hasSelections && totalPrice > 0) {
        const finalPrice = totalPrice;
        const finalPriceBefore = totalPriceBeforeDiscount;
        const finalCompare = totalCompareAtPrice || 0;

        // Prix barré = priorité au compare_at_price Shopify, sinon prix avant remise tier
        let priceToStrike = 0;
        if (finalCompare && finalCompare > finalPrice) {
          priceToStrike = finalCompare;
        } else if (finalPriceBefore && finalPriceBefore > finalPrice) {
          priceToStrike = finalPriceBefore;
        }

        if (priceToStrike > 0) {
          const formattedPriceBeforeDiscount = this.formatPrice(priceToStrike);
          const formattedPrice = this.formatPrice(finalPrice);

          this.priceDisplay.innerHTML = `
            <span class="price-discounted">${formattedPrice}</span>
            <span class="price-before-discount">${formattedPriceBeforeDiscount}</span>
          `;
        } else {
          const formattedPrice = this.formatPrice(finalPrice);
          this.priceDisplay.textContent = formattedPrice;
        }
      } else {
        this.updatePriceFromVariant();
      }
    }

    updatePriceFromVariant() {
      if (!this.priceDisplay || !this.submitButton) return;

      const newPrice = this.submitButton.dataset.productPrice;

      if (newPrice) {
        const price = parseInt(newPrice);
        const formattedPrice = this.formatPrice(price);
        this.priceDisplay.textContent = formattedPrice;
      }
    }

    formatPrice(priceInCents) {
      const priceInEuros = priceInCents / 100;
      return priceInEuros.toFixed(2).replace('.', ',') + '€';
    }

    setPrice(priceInCents) {
      if (!this.priceDisplay) return;
      const formattedPrice = this.formatPrice(priceInCents);
      this.priceDisplay.textContent = formattedPrice;
    }

    reset() {
      if (this.basePrice > 0) {
        this.setPrice(this.basePrice);
      }
    }
  }

  const manager = new ButtonPriceManager();
  window.ButtonPriceManager = manager;

  window.refreshButtonPrice = function() {
    manager.updatePriceFromVariant();
  };

  const readyEvent = new CustomEvent('buttonPriceManagerReady');
  document.dispatchEvent(readyEvent);

})();
